var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-overlay',{model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }